// @owners { team: patients }
import { type ShipmentTip } from '@alto/scriptdash/alto/orders/types/v1/shipment_tip';
import { SET_SHIPMENT_TIPS, type SetShipmentTipsAction } from '~shared/features/courier-tips/actions/setShipmentTips';

export type ShipmentTipsState = {
  shipmentTips: ShipmentTip[];
};

const initialState: ShipmentTipsState = {
  shipmentTips: [],
};

function shipmentTips(state: ShipmentTipsState = initialState, action: SetShipmentTipsAction): ShipmentTipsState {
  switch (action.type) {
    case SET_SHIPMENT_TIPS:
      return { ...state, shipmentTips: action.payload };

    default:
      return state;
  }
}

export default shipmentTips;
